(function() {
  var DATA = {
    spiele: {
      label: 'Plattform',
      platforms: ['Switch','PS5','PS4','PS3','Xbox','GameBoy','NES / SNES','DS / 3DS','Andere','Sammlung'],
      prices: {
        'Switch':     {sehr_gut:[5,25], gut:[4,18], akzeptabel:[3,10]},
        'PS5':        {sehr_gut:[7,30],gut:[5,22], akzeptabel:[4,12]},
        'PS4':        {sehr_gut:[5,20], gut:[3,14], akzeptabel:[2,8]},
        'PS3':        {sehr_gut:[1,10], gut:[1,7],  akzeptabel:[1,4]},
        'Xbox':       {sehr_gut:[5,18], gut:[3,12], akzeptabel:[2,7]},
        'GameBoy':    {sehr_gut:[5,20], gut:[3,14], akzeptabel:[2,8]},
        'NES / SNES': {sehr_gut:[8,35], gut:[5,22], akzeptabel:[3,12]},
        'DS / 3DS':   {sehr_gut:[4,18], gut:[3,12], akzeptabel:[2,7]},
        'Andere':     {sehr_gut:[3,15], gut:[2,10], akzeptabel:[1,5]},
        'Sammlung':   {sehr_gut:[-1,-1],gut:[-1,-1],akzeptabel:[-1,-1]}
      },
      hint: 'Spiele müssen funktionsfähig sein. Ohne Hülle Abzug möglich. Große Sammlungen als Paket anbieten – Preis auf Anfrage.'
    },
    konsole: {
      label: 'Modell',
      platforms: ['Switch','Switch Lite','Switch OLED','PS5','PS4','PS3','Xbox Series','Toniebox','Andere','Sammlung'],
      prices: {
        'Switch':      {sehr_gut:[70,120], gut:[55,95],  akzeptabel:[40,70]},
        'Switch Lite': {sehr_gut:[50,90],  gut:[40,70],  akzeptabel:[30,55]},
        'Switch OLED': {sehr_gut:[90,140], gut:[70,110], akzeptabel:[55,85]},
        'PS5':         {sehr_gut:[200,320],gut:[160,260],akzeptabel:[120,190]},
        'PS4':         {sehr_gut:[50,110], gut:[45,85],  akzeptabel:[30,60]},
        'PS3':         {sehr_gut:[25,50],  gut:[18,40],  akzeptabel:[10,28]},
        'Xbox Series': {sehr_gut:[150,270],gut:[120,210],akzeptabel:[90,160]},
        'Toniebox':    {sehr_gut:[40,70],  gut:[30,55],  akzeptabel:[20,40]},
        'Andere':      {sehr_gut:[15,60],  gut:[10,45],  akzeptabel:[5,30]},
        'Sammlung':    {sehr_gut:[-1,-1],  gut:[-1,-1],  akzeptabel:[-1,-1]}
      },
      hint: 'Mit Originalzubehör (Controller, Kabel, OVP) deutlich höhere Preise möglich. Mehrere Konsolen als Sammlung – Preis auf Anfrage.'
    },
    tonie: {
      label: 'Art',
      platforms: ['Standard Figur','Rarität / eingestellt','Tonie Set','Toniebox','Sammlung'],
      prices: {
        'Standard Figur':        {sehr_gut:[5,9],   gut:[4,7],   akzeptabel:[2,5]},
        'Rarität / eingestellt': {sehr_gut:[20,80], gut:[15,60], akzeptabel:[10,40]},
        'Tonie Set':             {sehr_gut:[12,30], gut:[8,22],  akzeptabel:[5,14]},
        'Toniebox':              {sehr_gut:[40,70], gut:[30,55], akzeptabel:[20,40]},
        'Sammlung':              {sehr_gut:[-1,-1], gut:[-1,-1], akzeptabel:[-1,-1]}
      },
      hint: 'Raritäten erzielen deutlich höhere Preise. Große Sammlungen gerne als Paket anbieten – Preis auf Anfrage.'
    },
    film: {
      label: 'Format',
      platforms: ['DVD','Blu-ray','4K Blu-ray','DVD Box Set','Blu-ray Box Set','Sammlung'],
      prices: {
        'DVD':             {sehr_gut:[0.10,0.10], gut:[0.10,0.10], akzeptabel:[0.10,0.10]},
        'Blu-ray':         {sehr_gut:[1,6], gut:[1,4], akzeptabel:[1,3]},
        '4K Blu-ray':      {sehr_gut:[4,9], gut:[3,7], akzeptabel:[2,5]},
        'DVD Box Set':     {sehr_gut:[0.10,0.10],gut:[0.10,0.10], akzeptabel:[0.10,0.10]},
        'Blu-ray Box Set': {sehr_gut:[5,15],gut:[4,11],akzeptabel:[2,7]},
        'Sammlung':        {sehr_gut:[-1,-1],gut:[-1,-1],akzeptabel:[-1,-1]}
      },
      hint: 'Alle Discs (Blu-ray, 4K Blu-ray) müssen kratzfrei sein – DVDs werden nur zu 0,10 € angekauft. Große Film-Sammlungen als Paket anbieten – Preis auf Anfrage.'
    },
    zubehoer: {
      label: 'Art',
      platforms: ['Controller','Headset','Speicherkarte','Kabel / Adapter','Sonstiges','Sammlung'],
      prices: {
        'Controller':      {sehr_gut:[15,40],gut:[10,28],akzeptabel:[5,16]},
        'Headset':         {sehr_gut:[8,25], gut:[5,18], akzeptabel:[3,10]},
        'Speicherkarte':   {sehr_gut:[3,12], gut:[2,8],  akzeptabel:[1,5]},
        'Kabel / Adapter': {sehr_gut:[1,5],  gut:[1,3],  akzeptabel:[0,2]},
        'Sonstiges':       {sehr_gut:[3,15], gut:[2,10], akzeptabel:[1,5]},
        'Sammlung':        {sehr_gut:[-1,-1],gut:[-1,-1],akzeptabel:[-1,-1]}
      },
      hint: 'Zubehör nur mit vollem Funktionstest. Große Zubehör-Sammlungen als Paket anbieten – Preis auf Anfrage.'
    }
  };
 
  var Z_LABELS = {sehr_gut:'Sehr gut', gut:'Gut', akzeptabel:'Akzeptabel'};
  var Z_COLORS = {sehr_gut:'green', gut:'amber', akzeptabel:'red'};
  var kat = 'spiele';
  var platform = DATA.spiele.platforms[0];
  var zustand = 'sehr_gut';
  var lastPriceText = ''; // für WhatsApp-Link: letzter berechneter Preis als Text
 
  function renderPlatforms() {
    var d = DATA[kat];
    var labelEl = document.getElementById('akr-platform-label');
    var wrap = document.getElementById('akr-platform-btns');
    if (!labelEl || !wrap) return;
    labelEl.textContent = d.label;
    wrap.innerHTML = '';
    platform = d.platforms[0];
    d.platforms.forEach(function(p, i) {
      var b = document.createElement('button');
      b.className = 'akr-btn' + (i === 0 ? ' active' : '');
      b.textContent = p;
      b.addEventListener('click', function() {
        wrap.querySelectorAll('.akr-btn').forEach(function(x){ x.classList.remove('active'); });
        b.classList.add('active');
        platform = p;
        update();
      });
      wrap.appendChild(b);
    });
  }
 
  function update() {
    var prices  = DATA[kat] && DATA[kat].prices[platform] && DATA[kat].prices[platform][zustand];
    var priceEl = document.getElementById('akr-price');
    var noteEl  = document.getElementById('akr-note');
    var tagP    = document.getElementById('akr-tag-p');
    var tagZ    = document.getElementById('akr-tag-z');
    var hintEl  = document.getElementById('akr-hint');
    var result  = document.getElementById('akr-result');
    if (!priceEl) return;
    if (prices) {
      if (prices[0] === -1) {
        priceEl.textContent = 'auf Anfrage';
        noteEl.textContent  = 'Bitte direkt kontaktieren';
        lastPriceText = 'auf Anfrage';
      } else {
        var fmt = function(n){ return n % 1 !== 0 ? n.toFixed(2).replace('.',',') : n; };
        var lo = fmt(prices[0]); var hi = fmt(prices[1]);
        priceEl.textContent = lo === hi ? lo + ' €' : lo + ' – ' + hi + ' €';
        noteEl.textContent  = 'Richtwert · Endpreis nach Prüfung';
        lastPriceText = priceEl.textContent;
      }
      result.classList.add('has-price');
    }
    tagP.textContent = platform || '–';
    tagZ.textContent = Z_LABELS[zustand] || zustand;
    tagZ.className   = 'akr-tag-badge ' + (Z_COLORS[zustand] || 'neutral');
    hintEl.innerHTML = '<strong>Hinweis:</strong> ' + (DATA[kat].hint || '');
  }
 
  function bindWhatsAppCta() {
    var cta = document.querySelector('.akr-cta');
    if (!cta) return false;
    if (cta.dataset.waBound) return true;
    cta.dataset.waBound = '1';
 
    cta.addEventListener('click', function(e) {
      // Nur WhatsApp öffnen, wenn schon ein Richtwert berechnet wurde
      if (!lastPriceText) return; // normales Scrollverhalten zu #kontakt beibehalten
 
      e.preventDefault();
 
      var katLabel = document.querySelector('#akr-kat-btns .akr-btn.active');
      katLabel = katLabel ? katLabel.textContent.trim() : kat;
 
      var text = 'Hallo! Ich möchte folgenden Artikel verkaufen:\n' +
        'Kategorie: ' + katLabel + '\n' +
        (platform ? 'Plattform/Art: ' + platform + '\n' : '') +
        'Zustand: ' + (Z_LABELS[zustand] || zustand) + '\n' +
        'Richtwert laut Ankaufsrechner: ' + lastPriceText + '\n\n' +
        'Kann ich euch dazu ein paar Fotos schicken?';
 
      var url = 'https://wa.me/436645010043?text=' + encodeURIComponent(text);
      window.open(url, '_blank');
    });
 
    return true;
  }
 
  function init() {
    var katBtns = document.getElementById('akr-kat-btns');
    if (!katBtns) return;
 
    katBtns.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-kat]');
      if (!btn) return;
      kat = btn.dataset.kat;
      katBtns.querySelectorAll('.akr-btn').forEach(function(x){ x.classList.remove('active'); });
      btn.classList.add('active');
      renderPlatforms();
      update();
    });
 
    document.querySelectorAll('[data-z]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('[data-z]').forEach(function(x){ x.classList.remove('active'); });
        btn.classList.add('active');
        zustand = btn.dataset.z;
        update();
      });
    });
 
    // FAQ — mit MutationObserver falls DOM noch nicht fertig
    function bindFaq() {
      var faqs = document.querySelectorAll('.ak-faq-q');
      if (faqs.length === 0) return false;
      faqs.forEach(function(btn) {
        // Doppelbindung vermeiden
        if (btn.dataset.faqBound) return;
        btn.dataset.faqBound = '1';
        btn.addEventListener('click', function() {
          var item = this.closest('.ak-faq-item');
          var isOpen = item.classList.contains('open');
          document.querySelectorAll('.ak-faq-item.open').forEach(function(el){ el.classList.remove('open'); });
          if (!isOpen) item.classList.add('open');
        });
      });
      return true;
    }
 
    if (!bindFaq()) {
      // FAQ noch nicht im DOM — warten bis es erscheint
      var faqObserver = new MutationObserver(function() {
        if (bindFaq()) faqObserver.disconnect();
      });
      faqObserver.observe(document.body, { childList: true, subtree: true });
    }
 
    // WhatsApp-CTA — mit MutationObserver falls .akr-cta noch nicht im DOM
    if (!bindWhatsAppCta()) {
      var ctaObserver = new MutationObserver(function() {
        if (document.querySelector('.akr-cta')) {
          bindWhatsAppCta();
          ctaObserver.disconnect();
        }
      });
      ctaObserver.observe(document.body, { childList: true, subtree: true });
    }
 
    renderPlatforms();
    update();
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
 